module.exports = __webpack_public_path__ + "static/aws_s3_permissions-6e7b734f22ff21526360e819091bfb0f.png";